import {appFetch} from "../../utils/appFetch";


export interface AppFetchResponse {
    data: any;
    status: number;
}

function unwrap<T>(res: AppFetchResponse): { ok: boolean; data?: T; error?: string } {
    const ok = res.status >= 200 && res.status < 300;
    const payload = res?.data;
    if (payload && typeof payload === "object" && "data" in payload) {
        return { ok, data: (payload as any).data as T, error: (payload as any).error };
    }
    return { ok, data: payload as T, error: (payload as any)?.error };
}

export type TreeBundle = {
    root_condition_id: number;
    conditionsById: Record<string, any>;
    itemsByConditionId: Record<string, any[]>;
    basicById: Record<string, any>;
};

export const GetConditionTreeBundle = async (domain: string, rootConditionId: number) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/conditions/${rootConditionId}/tree-bundle`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        domain,
    });

    return unwrap<TreeBundle>(res);
};

export const CreateChildGroup = async (
    domain: string,
    parentConditionId: number,
    input: { operator: "AND" | "OR"; title: string; sort_order: number }
) => {
    // IMPORTANT: appFetch CallProps likely uses "data" not "body"
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/conditions/${parentConditionId}/group`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain,
        data: input,
    } as any);

    return unwrap<{ childConditionId: number; conditionItemId: number }>(res);
};
